import { Roles } from "../utils/constants";
import Login from "../views/Auth/Login";
import Register from "../views/Auth/Register";
import ResetPassword from "../views/Auth/ResetPassword";
import ResetPasswordConfirm from "../views/Auth/ResetPasswordConfirm";
import Verification from "../views/Auth/Verification";
import EmploymentList from "../views/Employment/EmploymentList";
import CategoryList from "../views/Category/CategoryList";
import RequestList from "../views/Availability/RequestList";
import RosterCodeList from "../views/RosterCode/RosterCodeList";
import Statistics from "../views/Statistics/Statistics";
import UsersList from "../views/Users/UsersList";
import Profile from "../views/Profile";
import TimeSheetList from "../views/TimeSheets/TimeSheetList";

export const PublicRoutes = [
  {
    path: "/login",
    view: Login,
  },
  {
    path: "/register",
    view: Register,
  },
  {
    path: "/reset-password",
    view: ResetPassword,
  },
  {
    path: "/reset-password/confirm",
    view: ResetPasswordConfirm,
  },
  {
    path: "/verification",
    view: Verification,
  },
];

export const PrivateRoutes = [
  {
    path: "/employments",
    view: EmploymentList,
  },
  {
    path: "/categories",
    view: CategoryList,
    roles: [Roles.EMPLOYER.value]
  },
  {
    path: "/users",
    view: UsersList,
    roles: [Roles.ADMIN.value],
  },
  {
    path: "/requests",
    view: RequestList,
  },
  {
    path: "/codes",
    view: RosterCodeList,
    roles: [Roles.EMPLOYEE.value],
  },
  {
    path: "/statistics",
    view: Statistics,
    roles: [Roles.EMPLOYER.value, Roles.EMPLOYEE.value],
  },
  // {
  //   path: "/timesheets",
  //   view: TimeSheetList,
  //   roles: [Roles.EMPLOYEE.value],
  // },
  {
    path: "/profile",
    view: Profile,
    roles: [Roles.EMPLOYER.value, Roles.EMPLOYEE.value],
  },
];
